<script>
import Header from './Header.vue';
import ScrollToTop from './ScrollToTop.vue'

export default {  
  components: {
    'header-component': Header,
    ScrollToTop
  },
  mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },

      
    },
}
</script>

<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>
          <h1>Legal Notice</h1>
        </div>
      </div>
    </div>
    
    <div class="body">
      <p class="subhead">Last Updated April 30, 2021 </p>
      
      <p>
        This website is provided to you under these "Terms of Use" and any amendments or supplements to them (collectively referred to as this "Agreement") that may be posted by or one of its affiliated companies (collectively, "Site Owner," "we", "us") from time to time. Your use of this Website, or any other services or content provided through the Website [or Mobile Software], shall be deemed to constitute your consent to be legally bound by the terms and conditions of the Agreement, which shall be enforceable in the same way as if you had signed the Agreement. If you are not willing to accept the terms and conditions in the Agreement, we ask that you not access or use the Website or post or submit any materials on it. 
      </p>
      <p class="subhead">Information Disclaimer</p>
      <p>
        THE INFORMATION INCLUDING ANY ADVICE AND RECOMMENDATIONS ON THE WEBSITE IS INTENDED SOLELY AS A GENERAL EDUCATIONAL AID. IT IS NOT INTENDED AS MEDICAL OR HEALTHCARE ADVICE, OR TO BE USED FOR MEDICAL DIAGNOSIS OR TREATMENT, FOR ANY INDIVIDUAL PROBLEM. IT IS ALSO NOT INTENDED AS A SUBSTITUTE FOR PROFESSIONAL ADVICE AND SERVICES FROM A QUALIFIED HEALTHCARE PROVIDER FAMILIAR WITH YOUR UNIQUE FACTS. ALWAYS SEEK THE ADVICE OF YOUR DOCTOR OR OTHER QUALIFIED HEALTHCARE PROVIDER REGARDING ANY MEDICAL CONDITION AND BEFORE STARTING ANY NEW TREATMENT. YOUR USE OF THE SITE IS SUBJECT TO THE ADDITIONAL DISCLAIMERS AND CAVEATS THAT MAY APPEAR THROUGHOUT THE WEBSITE.  
      </p>
      <p>
        WE ASSUME NO RESPONSIBILITY FOR ANY CONSEQUENCE RELATING DIRECTLY OR INDIRECTLY TO ANY ACTION OR INACTION YOU TAKE BASED ON THE INFORMATION, SERVICES, OR OTHER MATERIAL ON THE WEBSITE. WHILE WE STRIVE TO KEEP THE INFORMATION ON THE WEBSITE ACCURATE, COMPLETE, AND UP-TO-DATE, WE DO NOT GIVE ANY ASSURANCES, AND WILL NOT BE RESPONSIBLE FOR, ANY DAMAGE OR LOSS RELATED TO THE ACCURACY, COMPLETENESS, OR TIMELINESS OF THE INFORMATION ON THE WEBSITE. 
      </p>
      <p class="subhead">Ownership</p>
      <p>
        You understand that the Website is available for your personal, non-commercial use only. You agree that the Website is the property of the Site Owner; including all intellectual property rights in it and that you have no right to use them other than as set out in these Terms of Use. We are not responsible for any harm or loss that you suffer in relation to any use you make of the Website for any business purposes or other purposes not authorized under these Terms of Use. We reserve the right to refuse or terminate access to the Website at our discretion. The Website are provided free of charge and on that basis we have no obligation to provide any maintenance or support services in relation to them and we are not responsible for any loss or damage you may suffer as a result of any failure to maintain or update the Website. 
      </p>
      <p>
        You may not copy, change or reuse the Website, any updates to them or any part of them including the software incorporated in them. You may use this Website only for lawful purposes and in accordance with these Terms of Use. You are granted a nonexclusive, nontransferable, revocable, limited license to view, print and distribute content retrieved from the Website for your personal, noncommercial purposes, provided that you do not remove or obscure the copyright notice or other notices displayed on the content. You may not copy, reprint, modify, display, perform, translate, distribute, adapt, broadcast, communicate to the public by telecommunication, circulate, or sell the content retrieved from the Website in any way, for any commercial use or provide it to any commercial source, including other websites, without the prior written permission of Site Owner. 
      </p>
      <p>
        In addition, you agree not to: (i) use this Website in any manner that could disable, overburden, damage, or impair this Website, or interfere with any other use of this Website, including, any user's ability to engage in real-time activities through this Website; (ii) use any robot, spider or other automatic device, process or means to access this Website for any purpose, including to scrape, data mine, monitor or copy any of the material on this Website; (iii) use any manual process to monitor or copy any of the material on this Website, or to engage in any other unauthorized purpose without the express prior written consent of Site Owner; (iv) otherwise use any device, software or routine that interferes with the proper working of this Website; or (v) otherwise attempt to interfere with the proper working of this Website. 
      </p>
      <p>We reserve all rights not expressly granted to you. </p>
      <p class="subhead">Privacy and Consent to Use Data </p>
      <p>
        The information that we obtain through your use of the Website, whether through the registration process or otherwise, is subject to our Privacy Policy. Our Privacy Policy addresses our collection and use of the data you provide to us, including your rights relative to that information.
      </p>
      <p class="subhead">Electronic Communications</p>
      <p>
        The information communicated on the Website constitutes an electronic communication. When you communicate with us through the Website or via other forms of electronic media, such as e-mail, you are communicating with us electronically. You agree that we may communicate electronically, subject to local privacy laws, and that such communications, as well as notices, disclosures, agreements, and other communications that we provide to you electronically, are equivalent to communications in writing and shall have the same force and effect as if they were in writing and signed by the party sending the communication. 
      </p>
      <p class="subhead">User Submissions</p>
      <p>
        We have created, or may create in the future, certain areas, such as message boards and chat rooms, within the Website where members can upload and share their thoughts, comments, product reviews, pictures, videos and the like with other members (collectively, "Forums"). These Forums may be available to registered members of the Website only. To help ensure that the text, graphics, software, music, sound, photographs, videos, messages, posts, data, information, or other materials posted by users (collectively, the "User Content") is beneficial for the greater community, we have established some basic rules for everyone to follow. 
      </p>
      <p>
        In addition, if a Forum is provided within the Website, it may allow users to post questions to be answered by experts engaged by us. Where applicable, these experts are paid by us for their time in responding to members' questions, but the opinions they express are their own. We are providing access to the experts and their guidance in the Forum solely as an informational and educational service to members of the Website. 
      </p>
      <p>
        Our policy for this Website is to review User Content, as far as practical, either before or after such User Content is posted. Pre-moderation means that the User Content will not be posted to the Forum and cannot be accessed or viewed by other Website members until we have reviewed it and determined that the User Content is suitable for posting to the Forum. This process also means that User Content submitted for posting will not be posted in real time and may never be posted if we determine that it is unsuitable for the Website. Post-moderation means that User Content will be reviewed by us once it is already posted on the Website. Post-moderated User Content that Site Owner determines does not comply with these Terms or is otherwise unsuitable for the Website will be removed from the Website, without notice to the User. 
      </p>
      <p>
        User Content must be appropriate for the Forum. Without limiting the reasons for which User Content may be rejected by us, we may reject, edit or remove any User Content that does not comply with any Community Guidelines that we provide, which you must read prior to posting any User Content on the Website.
      </p>
      <p>
        By submitting User Content for posting at a Forum, you also (1) confirm that you are entitled to post or transmit User Content; (2) agree that you are solely responsible for all User Content that you submit for posting; and (3) grant to Site Owner and its affiliated entities an irrevocable, worldwide, nonexclusive, perpetual, fully sub-licensable, transferable, royalty-free right and license to use, your User Content in any way on the Website and on any other Website owned or operated by Site Owner or its affiliates (as well as on any social media sites associated with the Site Owner or its affiliates). 
      </p>
      <p>
        We are free to use any ideas, concepts, know-how, or techniques contained in or derived from any User Content for any purpose whatsoever, including developing, manufacturing, and marketing products. Therefore please do not submit or send to us any ideas, suggestion or materials that you wish to keep confidential or for which you expect to receive compensation. You will not have any claim against us with respect to any use or non-use of User Content. When you submit User Content, you understand that we will have the right, but not the obligation, to use, display and publish your name, photograph, likeness, voice, performance, biographical information and/or statements, throughout the world in perpetuity on the Website and on any affiliate or successor Website or social media channels owned or operated by us or our affiliates. If we make use of any of these rights, you understand and agree that you shall not receive any other consideration, payment, notification or credit, nor will you have any approval over how Site Owner uses them.  
      </p>
      <p>
        You acknowledge that the Forums contain the opinions and views of other users. You acknowledge further that we are not responsible for the accuracy of any User Content on the Website. You understand and agree that all User Content is the sole responsibility of the person who posted the Content. You understand and agree that you will evaluate, and bear all risks associated with, the use of any User Content, including any reliance on the accuracy, completeness, or usefulness of such User Content.  
      </p>
      <p>
        We reserve the right at any time to discontinue, temporarily or permanently, your ability to upload User Content and/or your ability to access User Content with or without notice, at our sole discretion. You agree that we shall not be liable to you or to any third party for any suspension or discontinuance of acceptance of User Content.  
      </p>
      <p>
        Remember that all User Content you submit to the Website through a mobile device will be stored on that mobile device. The security and safety of your mobile device, and the information and materials contained on it, as well as any password you use on your device and to access the Website are your sole responsibility.  
      </p>
      <p class="subhead">Storage of User Content </p>
      <p>
        We may impose a maximum amount of storage for User Content on the Website. We are not responsible for any loss or harm you may suffer as a result of any deletion or failure to store any messages, communications or other User Content associated with maintaining the maximum amount of storage.  
      </p>
      <p class="subhead">Disclaimer of Warranties With Respect to Use of Website</p>
      <p>
        THE WEBSITE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. EXCEPT AS SPECIFICALLY PROVIDED HEREIN, TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, SITE OWNER EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, LEGAL OR IMPLIED, INCLUDING, WITHOUT LIMITATION, ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. 
      </p>
      <p>
        OWNER DOES NOT MAKE ANY WARRANTY THAT THE WEBSITE WILL MEET YOUR REQUIREMENTS, OR THAT ACCESS TO THE WEBSITE WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, OR THAT DEFECTS, IF ANY, WILL BE CORRECTED. SITE OWNER MAKES NO WARRANTIES AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE WEBSITE OR AS TO THE ACCURACY, QUALITY, OR RELIABILITY OF ANY INFORMATION OBTAINED THROUGH THE WEBSITE. 
      </p>
      <p>
        YOU UNDERSTAND AND AGREE THAT ANY MATERIAL AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE WEBSITE IS USED AT YOUR OWN RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA. 
      </p>
      <p>
        NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM SITE OWNER OR THROUGH THE WEBSITE SHALL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN.  
      </p>
      <p class="subhead">Limitations of Liability</p>
      <p>
        YOU EXPRESSLY UNDERSTAND AND AGREE THAT UNDER NO CIRCUMSTANCES WILL SITE OWNER, ITS AFFILIATES AND ANY OF THEIR RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, MANDATARIES OR OTHER REPRESENTATIVES BE LIABLE FOR DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR AGGRAVATED DAMAGES, INCLUDING, WITHOUT LIMITATION, ANY LOSS OF USE, LOSS OF INCOME, SAVING OR PROFITS, LOSS OF DATA, LOSS OF GOODWILL, COST OF PROCUREMENT OF SUBSTITUTE SERVICES, OR ANY OTHER INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, HOWSOEVER CAUSED, AND ON ANY THEORY OF LIABILITY, WHETHER FOR BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE AND STRICT LIABILITY), OR OTHERWISE RESULTING FROM (1) THE USE OF, OR THE INABILITY TO USE, THE WEBSITE; (2) THE COST OF PROCUREMENT OF SUBSTITUTE SERVICES, ITEMS, OR WEBSITES; (3) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA (INCLUDING PERSONAL INFORMATION); (4) THE STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE WEBSITE; OR (5) ANY OTHER MATTER RELATING TO THE WEBSITE. THESE LIMITATIONS WILL APPLY WHETHER OR NOT SITE OWNER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY. THIS EXCLUSION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAWS.
      </p>
      <p class="subhead">Trademark Notices </p>
      <p>
        The trademarks and brand names displayed on this Website are the property of Site Owner, its affiliates or third party owners. You may not use or display any trademarks or service marks owned by Site Owner without our prior written consent. You may not use or display any other trademarks or service marks displayed on this Website without the permission of their owners. 
      </p>
      <p class="subhead">Modification or Suspension of the Website </p>
      <p>
        We will make reasonable efforts to make the Website available but we may from time to time need to interrupt, restrict, modify or discontinue, temporarily or permanently the Website or parts of it without notice. We will not be responsible for any harm or loss you may suffer as a result of such actions. 
      </p>
      <p class="subhead">Termination</p>
      <p>
        We may at any time terminate your use of or access to the Website and may delete any or all of your User Content without prior notice if we have a good reason to do so which includes any breach by you of these Terms of Use and the Community Guidelines. We will not be responsible for any loss or harm you may suffer as a result of termination of your use of the Website in these circumstances. In the event of any termination you must stop using the Website and you agree that the provisions of the Agreement regarding Ownership, Trademark Notices, Indemnification, Disclaimer or Warranties, Limitations of Liability, and Applicable Law shall survive any such termination.  
      </p>
      <p class="subhead">Links to Third Party Sites </p>
      <p>
        This Website may contain links or references to third party websites. These links are provided for your convenience only. No endorsement of any third party products, services or information is expressed or implied by any information, material or content of any third party contained in, referred to, included on, or linked from or to this Website. Any information, data, opinions, recommendations, products or services provided by such third parties through links to other websites or otherwise made available through their websites are solely those of such third parties and not of Site Owner. Your use of such third party websites is subject to the terms of use and the privacy policies of such websites. 
      </p>
      <p class="subhead">Indemnification</p>
      <p>
        You agree to indemnify and hold harmless Site Owner and its affiliates and their respective directors, officers, employees, agents, or other representatives from and against all claims, liability, damages and expenses, including without limitation all legal fees and costs arising from or relating to (a) your breach of these Terms of Use; (b) your use of this Website including without limitation transmission or placement of information or material by you on this Website; and (c) any claim or allegation that any of your User Content infringes the intellectual property or other proprietary rights, or privacy rights, of any third party.
      </p>
      <p class="subhead">Modifications to These Terms</p>
      <p>
        We may make changes to the Terms of Use from time to time in our sole discretion, by updating these Terms of Use on this Website, and specifying the effective date of the new version of the Terms of Use. The "Last Modified" date at the top of these Terms of Use will indicate when the latest changes were made. Your continued use of the Website following the posting of a new version of the Terms of Use constitutes your acceptance of any such changes. Accordingly, whenever you visit this Website, you should check to see if a new version of the Agreement has been posted.  
      </p>
      <p class="subhead">Contact Information </p>
      <p>
        If you have any questions or concerns with respect to these Terms of Use or the Website you may contact us as identified in the Privacy Policy or the "Contact Us" section of this Website. 
      </p>
      <p class="subhead">Severability of Agreement </p>
      <p>
        Should any part or provision of these Terms of Use be held unlawful, void, invalid, or unenforceable that portion shall be deemed severable from these Terms of Use and shall not affect the validity and enforceability of any remaining provisions. 
      </p>
      <p class="subhead">Survival</p>
      <p>
        All Sections shall survive the termination of the right to use the Website. 
      </p>
      <p class="subhead">Applicable Law and Jurisdiction</p>
      <p>
        The information on the Website is intended only for use by residents of the United States and its territories. Other countries may have laws, regulatory requirements, or medical practices that differ from those in the United States. The Agreement and the resolution of any dispute related to the Agreement, the Website, or items you purchase through the Website, and any non-contractual obligations arising out of or in connection with these Terms of Use, shall be governed by and construed in accordance with the laws of New Jersey, USA, without giving effect to any principles of conflicts of law. Any legal action or proceeding between Site Owner and you related to the Agreement shall be brought exclusively in a court of competent jurisdiction sitting in New Jersey, USA, and you agree to submit to the personal and exclusive jurisdiction of such courts.  
      </p>

      <ScrollToTop />

    </div>



  
  </div>

</template>

<style scoped>
#app > div {
  width: 100%;
  }

/*TOP */

  .top-wrap{
    background: rgb(0,18,82);
    background: linear-gradient(0deg, rgba(0,18,82,1) 0%, rgba(0,70,126,1) 50%, rgba(0,70,126,1) 100%);
    color: #ffffff;
    padding-bottom: 60px;
    width: 100%;
  }
  .top-content{
    background: linear-gradient(to top, #0079A8, #0084B8);
    border-radius: 0 0 0 100px;
    margin-left: 3%;
    padding-bottom: 20px;
    width: 97%;
  }

  .top-content p{
    font-size: 18px;
    line-height: 24px;
    margin: 27px auto 18px auto;
    text-align: center;
    width: 90%;
  }

  .top-banner{
    background: url(../img/banner-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    height: 320px;
    margin-left: 1.5%;
    width: 98.5%;
  }

.top-banner h1{
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 36px;
  line-height: 46px;
  margin: 68px auto 20px auto;
  text-align: center;
}
.top-banner h2{
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 22px;
  font-style: italic;
  font-weight: 100;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.top-banner sup {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-top;
}

.top-banner section{
  font-family: GothamBook, sans-serif;
  font-size: 18px;
  margin: 40px auto 0 auto;
  text-align: center;
  width: 1040px;  
}

.top-content p.banner-footer{
  font-family: GothamBook, sans-serif;
  font-size: 24px;
  text-align: center;
}

.bottom-banner{
  color: #00a0df;
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 70px auto 0 auto;
  text-align: left;
  width: 1120px;
}

.bottom-banner-text{
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.bottom-banner-text sup{
  font-size: 11px;
  font-weight: 400;
  position: relative;
  top: -0.2em;
  vertical-align: top;
}

.list-content{
  background: #eeeef3;
  margin: 0 auto;
  padding-bottom: 50px;
  position: relative;
  width: 100%;
}

.list-wrap{
  background: #eeeef3;
  color: #6f6f6f;
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 20px;
  margin: 65px auto;
  width: 90%;
}

.list-wrap ul, .list-wrap ol{
  padding-left: 20px;
}
.list-wrap ul li{
  padding-bottom: 10px;
  text-indent: -9px;
}

.list-wrap ol li{
  padding-bottom: 10px;
  padding-left: 8px;
}

.list-wrap ol li::marker{
  color: #00a0df;
  font-weight: bold;
  margin-right: 10px;
}

.list-wrap ul li::before{
  color: #00a0df;
  content: "\2022";
  font-weight: bold;
  display: initial;
  margin-left: -10px;
  padding-right: 10px;
}

.list-item{
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  padding: 22px 42px;
  position: relative;
  vertical-align: top;
}

.list-item-tit{
  font-family: GothamBook, sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
}

.list-item-subtit{
  font-weight: bold;
}

.no-top-margin{
  margin-top: 0;
}

li ul.sublist{
  margin-top: 10px;
}

li ul.sublist li::before{
  content: "–";
  padding-right: 0px;
  margin-right: 0;
}


.less-bottom-margin{
  margin-bottom: 5px;
}

.top-link{
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: 35px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 135px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}

.site-guide, #menuToggle, #boton, .home{
  display: none;
}

@media screen and (min-width:881px){
  .site-guide{
    background-color: #98b0ca !important;
  }

  .site-guide a{
    color: #becddd !important;
  }
}

@media screen and (max-width: 880px){ 

   .top-banner{
    background: url(../img/banner-mobile4-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: GothamBook, sans-serif;
    font-size: 28px;
    line-height: 30px;
    width: 86%;
  }
  .top-banner section p{
    margin: 23px 0;
  }
  
  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }  

  .list-wrap{padding-left: 0px;}

  .top-banner h2{
    width: 96%;
  }

  .bottom-banner{
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap{
    width: 95%;
  }

  .step-item{
    text-align: center;
  }

  .step-circle{
    margin: 60px 0 45px 0;
  }

  .step-item-desc-wrap{
    text-align: left;
  }

  .list-wrap{
    text-align: center;
    width: 100%;
  }

  .list-item{
    margin: 0 auto;
    text-align: left;
    width: 80%;
  }

  .list-item .button{
    width: 230px;
    background-size: contain;
  }

  .body{
    width: 90%;
  }
  
  .body .subhead{
    width: 100%;
  }

  .body-list-wrap, .body .references, .body-list-item button, .body-list-item .button{
    width: 100%;
  }

  .body-list-item {
    margin-right: 37px;
    width: 300px;
  }

  .list-item:nth-child(2n) {
    margin: 0;
  }

  .list-item:nth-child(3n) {
      margin: 0 32px 78px 0;
  }

  .body-list-item:nth-child(2n) {
    margin: 0;
  }

  .body-list-item:nth-child(3n) {
    margin: 0 32px 78px 0;
  }

  .list-content .subhead, .list-content .subhead-description{
    padding-left: 37px;
    padding-right: 37px;
    width: calc(100% - 74px);
  }

  .top-link{
    right: 35px;
  }

}


@media screen and (max-width: 415px){

  .resources .resource_info_wrap{
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources div a{
    display: block;
    height: 55px;
  }

  .resources > div button{
    width: 100%;
  }

  .resources > div, .resources div:nth-child(2n){
    width: 100%;
  }

  .top-banner sup {
    font-size: 9px;
  }

  .bottom-banner{
    padding-left: 30px;
    padding-right: 30px;
    width: calc(100% - 60px);
  }

  .list-item{
    margin: 0 0 60px 0px;
    padding: 22px 37px;
  }

  .top-banner section{
    font-size: 23px;
  }

  .top-content p{
    width: 90%;
    font-size: 14px;
    font-weight: 600;
  }

  .body{
    width: 86%;
  }

  .body-list-item, .body-list-item:nth-child(2n), .body-list-item:nth-child(3n), .list-item:nth-child(2n), .list-item:nth-child(3n){
    margin: 0 32px 78px 20px;
  }

  .top-content{
    padding-bottom: 8px;
  }

  .top-banner{
    height: 184px;
    min-height: 184px;
  }

  .top-banner h1{
    font-size: 18px;
    font-weight: 700;
    line-height: 23px;
    margin: 40px auto 20px auto;
  }

  .top-banner h2{
    font-size: 14px;
    line-height: 18px;
    width: 80%;
  }

  .top-banner h1 span{
    display: block;
    font-size: 14px;
    line-height: 18px;
    margin-top: 20px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

   @supports (-webkit-touch-callout: none) {
    .filter-list span{
      line-height: 32px;
    }

    .filter-content .apply{
      line-height: 70px;
    }

    .top-link{
      padding-top: 12px;
    }

  }

}

@media screen and (max-width: 880px){

    .top-banner header .logo img{
      width: 60%;
    }

    .top-content p{
      width: 80%;
    }

}


@media screen and (max-width: 1024px){

  .top-banner section{
    max-width: 95%;
  }

  footer img{
    left: 78%;
  }

  .top-banner *, .body * {
    max-width: 95%;
  }

  .home-body{
    max-width: 95%;
  }
}

@media screen and (max-width: 880px){

  .top-banner{
    background: url(../img/banner-mobile2-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: "GothamBook", sans-serif;
    font-size: 20px;
    line-height: 30px;
    font-weight: 100;
    width: 84%;
  }
  .top-banner section p{
    line-height: 20px;
  }

  .top-banner .super {
    font-size: 8px;
    font-weight: 100;
    margin: 0 0 0 2px;
    vertical-align: text-top;
}
  
  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .home-body{
    width: 87%;
  }

}

@media screen and (max-width: 540px){

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 21px auto;
  }

  .top-banner h1 span{
    display: block;
    font-size: 19px;
    line-height: 23px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

}

@media screen and (max-width: 320px){

  footer li[data-v-40ab164b]:nth-child(2n){
    width: 42%;
  }
}


/* new styles sergio */

@media screen and (max-width: 880px){
    #boton {
      right: 20px;
      top: 38px;
    }
    header input ~ #menuToggle{
      width: 40px;
      height: 27px;
      right: 40px;
      top: 45px;
      background-size: cover;
    }
    header input:checked~#menuToggle{
        width: 28px;
        height: 28px;
        right: 40px;
        top: 45px;
        background-size: cover;
        z-index: 10000;
    }

    .top-banner header .logo img{
      width: 60%;
    }

}

@media screen and (max-width: 415px){

  .list-item{
    width: 74%;
  }

}

</style>






// WEBPACK FOOTER //
// src/components/Legal_Notice.vue